import { getReq, getReqAuth } from '../../api';

export const getUserLevel = (cb) => getReqAuth('/webapi/institute/auth/user-level', {}, '', cb);

export const getAllPublicInstitutions = (cb) =>
	getReq('/webapi/institute/institution/get/public/institutions', {}, '', cb);
